// Chain ID constants
export const SUPPORTED_CHAIN_IDS = {
  // Mainnets (for future deployment)
//   linea: 59144,
//   base: 8453,
//   sonic: 146,
  
  // Testnets
  lineaTestnet: 59141,
  sonicTestnet: 57054,
} as const

export type ChainId = (typeof SUPPORTED_CHAIN_IDS)[keyof typeof SUPPORTED_CHAIN_IDS]
export type NetworkName = keyof typeof SUPPORTED_CHAIN_IDS 